<template>
  <div class="about">
      <section style="height: 100vh;overflow: hidden;" >
          <div style="height: 100vh;position: relative;">
              <el-row class="page-top" type="flex" justify="center" align="center">
                      <el-col :md="6" align="center" style="position: relative;">
                          <el-col :md="24" style="position: absolute;opacity: .2;letter-spacing: 5px;font-weight: bold;">
                              <h1 >INTRODUCTION</h1>
                          </el-col>
                          <el-col :md="24">
                              <h1 style="color: #fff;font-weight: bold;">{{$t('about.toptitle')}}</h1>
                              <h6>INTRODUCTION</h6>
                              <h6>小事做细 · 服务于心</h6>
                          </el-col>
                      </el-col>
              </el-row>
              <el-row type="flex" justify="center" align="center" class="menu hidden-sm-and-down">
                  <el-col :md="6"  align="center" class="item hover-hand" @click.native="selectModel(0)" :class="idx == 0 ? 'active':'lose'">
                      <h4>{{$t('about.info')}}</h4>
                  </el-col>
                  <el-col :md="6"  align="center" class="item hover-hand" @click.native="selectModel(1)" :class="idx == 1 ? 'active':'lose'">
                      <h4>{{$t('about.progress.info')}} | {{$t('about.honor.info')}}</h4>
                  </el-col>
                  <el-col :md="6"  align="center" class="item hover-hand" @click.native="selectModel(2)" :class="idx == 2 ? 'active':'lose'">
                      <h4>{{$t('about.social')}}</h4>
                  </el-col>
              </el-row>
              <el-row type="flex" justify="center">
                  <div class="more-page">
                      <p class="iconfont mh-weibiaoti-1-18"></p>
                      <p class="iconfont mh-weibiaoti-1-19 one"></p>
                      <p class="iconfont mh-weibiaoti-1-19 two"></p>
                  </div>
              </el-row>
          </div>
      </section>
      <section  class="cpninfo" id="about1" style="background-color: #fafafa;">
          <el-row type="flex" justify="center" align="center">
              <el-col :md="24" :xs="24">
                  <el-col :md="12" class="cpn-left">
                      <el-col :md="20" :xs="22">
                           <div class="title-opt">INTRODUCTION</div>
                           <div class="title-opt-title">{{$t('about.info')}}</div>
                           <div  >
                               <p>
                                   {{$t('about.detail')}}
                                </p>
                                   <p>
                                   {{$t('about.detail1')}}
                               </p>
                           </div>
                           
                      </el-col>
                  </el-col >
                  <el-col :md="12" class="cpn-right">
                      <el-row class="content">
                          <el-col :md="16">
                              <el-col :md="12" :xs="12" v-for="(item,index) in $t('home.cpninfo.aboutUs')" :key="index" >
                                  <p :data-s="item.msg" class="msg" :data-e="item.dataTag">{{item.Bdata}}</p>
                              </el-col>
                          </el-col>
                      </el-row>
                  </el-col>
              </el-col>
          </el-row>
      </section>
      <section class="cpn-detail" id="about2">
          <el-row type="flex" justify="center" class="detail-main">
              <el-col :md="20" :xs="22" >
                  <el-col :md="6" :xs="24" class="detail-left hidden-sm-and-down" >
                      <el-col :md="16" :xs="12" class="bg-item" @click.native="selectProgress(0)">
                          <div class="hover-hand" :class="curpro == 0 ? 'active':''">
                              <div >{{$t('about.progress.info')}}</div>
                              <p>COURSE</p>
                          </div>
                      </el-col>
                      <el-col :md="16" :xs="12" class="bg-item"  @click.native="selectProgress(1)">
                           <div class="hover-hand" :class="curpro ==1 ? 'active':''">
                               <div > {{$t('about.honor.info')}}</div>
                               <p>QUALIFICATION </p>
                           </div>
                      </el-col>
                  </el-col>
                  
                  <el-col :md="20" :xs="24" class="m-menu-title hidden-md-and-up">
                      <el-col :xs="12" :sm="12" @click.native="selectProgress(0)">
                          <div class="news-sub" :class="curpro ==0 ? 'active':''">COURSE</div>
                          <div class="news-title" :class="curpro ==0 ? 'active':''" >
                              {{$t('about.progress.info')}}
                          </div>
                      </el-col>
                      <el-col :xs="12" :sm="12" @click.native="selectProgress(1)">
                          <div class="news-sub" :class="curpro ==1 ? 'active':''">QUALIFICATION</div>
                          <div class="news-title" :class="curpro ==1 ? 'active':''">
                              {{$t('about.honor.info')}}
                          </div>
                      </el-col>
                      
                  </el-col>
                  <el-col :md="18" class="detail-right" >
                      <el-col :md="18">
                          <div style="font-size: 25px;font-weight: bold;padding-bottom: 50px;">{{$t('about.honorTitle')}}</div>
                          <div class="detail-list">
                              <p v-for="(item,index) in curProgress " :key="index">
                                  {{item.title}}
                              </p>
                          </div>
                      </el-col>
                  </el-col>
              </el-col>
          </el-row>
      </section>
      <section class="cpn-work" id="about3" style="background-color: #fafafa;">
          <el-row>
              <el-col >
                  <el-row type="flex" justify="center">
                      <el-col :md="20" class="h-menu-title">
                          <div class="news-sub">QUALIFICATION</div>
                          <div class="news-title">{{$t('about.social')}}</div>
                      </el-col>
                  </el-row>
                  <el-row type="flex" justify="center">
                         <el-col :md="20" :xs="22" >
                             <el-row  >
                                 <el-col :md="11" class="work-left">
                                     <el-row type="flex" justify="center" class="content">
                                         <el-col :md="18" class="detail">
                                             <div>{{$t('about.gy.title')}}</div>
                                             <div>{{$t('about.gy.info')}}</div>
                                         </el-col>
                                     </el-row>
                                 </el-col>
                                 <el-col :md="12"  class="work-right hidden-sm-and-down" >
                                     <el-col :md="24" class="item" style="padding: 0;">
                                         <div class="flex">
                                             <div class="thumb">
                                                 <div class="thumb-img" :style="{backgroundImage:'url('+rolesTop.img+')'}"></div>
                                             </div>
                                             <div class="content">
                                                 <div class="title" style="font-weight: bold;font-size: 18px;"><p>{{$t('about.cnews.rolesTop.title')}}</p> </div>
                                                 <div class="lue" >{{$t('about.cnews.rolesTop.content')}}</div>
                                             </div>
                                         </div>
                                     </el-col>
                                     <el-col :md="24"  class="item" style="padding: 0;" @click.native="redirect(rolesBtm.href)">
                                         <div class="flex">
                                            <div class="content">
                                                <div class="title" style="font-weight: bold;font-size: 18px;"><p>{{$t('about.cnews.rolesBtm.title')}}</p> </div>
                                                <div class="lue"> {{$t('about.cnews.rolesBtm.content')}}</div>
                                            </div>
                                            <div class="thumb">
                                                <div class="thumb-img" :style="{backgroundImage:'url('+rolesBtm.img+')'}"></div>
                                            </div>
                                         </div>
                                     </el-col>
                                 </el-col>
                                 
                                 <el-col :md="12"  class="work-list hidden-md-and-up" >
                                     <el-col :md="24" class="item" style="padding: 0;">
                                        <div class="thumb" :style="{backgroundImage:'url('+rolesTop.img+')'}"></div>
                                        <div class="content">
                                            <div class="title">{{$t('about.cnews.rolesTop.title')}}</div>
                                            <div class="lue" >{{$t('about.cnews.rolesTop.content')}}</div>
                                        </div>
                                     </el-col>
                                     <el-col :md="24"  class="item" style="padding: 0;" @click.native="redirect(rolesBtm.href)">
                                         <div class="thumb" :style="{backgroundImage:'url('+rolesBtm.img+')'}"></div>
                                         <div class="content">
                                             <div class="title">{{$t('about.cnews.rolesBtm.title')}}</div>
                                             <div class="lue" >{{$t('about.cnews.rolesBtm.content')}}</div>
                                         </div>
                                     </el-col>
                                 </el-col>
                             </el-row>
                         </el-col>
                  </el-row>
              </el-col>
          </el-row>
          
      </section>
      
  </div>
</template>
<script>
    import Swiper from 'swiper'
    export default{
        data(){
            return{
                idx:0,
                curpro:0,
                mySwiper:{},
                mySwiperMainIndex:0,
                swiperItemIdx:0,
                swipers:[],
                myOswiper:{},
                myTswiper:{},
                myHswiper:{},
                threeIdx:0,
                twoIdx:0,
                oneIdx:0,
                datas:[
                    {id:1,data:2015,tag:'年',msg:'业务板块'},
                    {id:1,data:120,tag:'名',msg:'在职员工'},
                    {id:1,data:4,tag:'大',msg:'业务板块'},
                    {id:1,data:15,tag:'年',msg:'内容暂定'},
                ],
                progress:[
                    [
                        {id:1,title:'2013年，博士妈妈Dr.Mums（以下简称DM)团队成立。'},
                        {id:2,title:'2015年，与瑞典拜奥BioGaia建立合作关系，成为拜奥中国区线上代理商。'},
                        {id:3,title:'2020年，红米粒FH公益服务中心成立，开始家族性高胆固醇血症患者服务。'},
                        {id:4,title:'2020年，开始半自动体外除颤器AED在国内的推广应用和急救知识的普及。'},
                        {id:5,title:'2021年，红米粒急救培训中心成立，成为西安第一家可在院外开展公众急救培训，具有HeartSaver课程发证资质的急救培训中心。'},
                        
                    ],
                    [
                        {id:1,title:'2021年，DrMums营养定制项目通过浙江杭州未来科技城（海创园）海外高层次人才项目评审。'},
                        {id:2,title:'2022年，深圳博妈通过深圳市2022年科技型中小企业评定。'},
                        {id:3,title:'2022年，博妈（杭州）网络科技有限公司认定为浙江省科技型中小企业。'}
                    ]
                ],
                rolesTop:{
                        id:1,date:'2023-02-04',title:'爱心公益行，冬日暖人心',
                        href:'',
                        img:'https://scan-code.oss-cn-hangzhou.aliyuncs.com/menhu/about/gy1.jpg',
                        content:'2023年2月4日，博士妈妈前往商洛市柞水县下梁镇金盆村为当地的村民和儿童送去关爱，捐赠物资包括果泥、衣物和运动鞋等。'
                    },
                rolesBtm:{
                        id:1,date:'2022-09-20',title:'【博士妈妈关爱儿童活动】让爱走进西安、三原儿童村',
                        img:'https://scan-code.oss-cn-hangzhou.aliyuncs.com/menhu/about/gy2.jpg',
                        href:'https://mp.weixin.qq.com/s/xiBKLM-5lNZ9nufxmuVbcA',
                        content:'2022年9月18日，博士妈妈携带229件衣服，25顶帽子，34双运动鞋，100箱果泥前往三原县东周儿童村、陕西省回归儿童资助中心，为儿童村的孩子们送去关爱。'
                    },
                curProgress:[]
            }
        },
        computed:{
          currentIdx(){
              return this.mySwiperMainIndex
          }  
        },
        mounted() {
            this.curProgress = this.$t('about.progress.datas')
           let that = this
          // 下面是普通swiper模板
          var swiper = new Swiper(".swiper-container-main", {
              loop: true,
              onwheel:true,
              direction: 'vertical',
              navigation: {}           
          });
          swiper.on('slideChangeTransitionEnd', function () {
               that.mySwiperMainIndex = swiper.realIndex;
          })
          that.mySwiper = swiper
          
          
          let oswiper = new Swiper(".swiper-onne", {
              loop: true,
              onwheel:true,
              navigation: {},
              on:{
                  slideChange:function(){
                      that.oneIdx = this.realIndex
                  }
              }
          });  
          //console.log(oswiper)
          that.myOswiper = oswiper[0]
          
          
          let twos = new Swiper(".swiper-two", {
                loop: true,
                onwheel:true,
                navigation: {},  
                on:{
                    slideChange:function(){
                        that.twoIdx = this.realIndex
                    }
                }
          });  
          //console.log(twos)
          that.myTswiper = twos
          
          let threes = new Swiper(".swiper-three", {
             loop: true,
             onwheel:true,
             navigation: {}, 
             on:{
                 slideChange:function(){
                     that.threeIdx = this.realIndex
                 }
             }
          });  
          //console.log(threes)
          that.myHswiper = threes[0]
        },
        methods:{
            redirect(href){
                window.open(href,'_blank')
            },
            selectProgress(idx){
               this.curpro = idx
               if(idx==0){
                   this.curProgress = this.$t('about.progress.datas')
               }else{
                   this.curProgress = this.$t('about.honor.datas')
               }
               
            },
            selectModel(idx){
                this.idx = idx
                switch(idx){
                    case 0:
                        this.scrollToSection('about1')
                        break;
                    case 1:
                        this.scrollToSection('about2')
                        break;
                    case 2:
                        this.scrollToSection('about3')
                        break;
                }
            },
            scrollToSection(sectionId) {
              const section = document.getElementById(sectionId);
              if (section) {
                section.scrollIntoView({ behavior: 'smooth' });
              }
            },
            prev(){
                let that = this
                let mainIdx = this.mySwiperMainIndex
                //console.log(mainIdx)
                switch(mainIdx){
                    case 0:
                        that.myOswiper.slideToLoop((that.oneIdx + 1)%4,1000,false)
                        break;
                    case 1:
                        that.myTswiper.slideToLoop((that.twoIdx + 1)%4,1000,false)
                        break;
                    case 2:
                    //console.log(mainIdx)
                        that.myHswiper.slideToLoop((that.threeIdx + 1)%4,1000,false)
                        break;
                }
            },
            next(){
                
            },
            change(index){
                this.mySwiperMainIndex = index
                this.mySwiper.slideToLoop(index, 1000, false)
            },
            
        }
    }
</script>
<style lang="scss" scoped>
    @import '../assets/mh.scss';
    .cpn-work{
        @media only screen and (min-width:992px){
            height: 100vh;
            display: flex;
            align-items: center
        }
        .work-list{
            margin-top: 20px;
            .item{
                &+.item{
                    margin-top: 20px;
                }
                border: 1px solid rgba(0, 0, 0, 0.1);
                .thumb{
                    width: 100%;
                    height: 220px;
                    background-image: url('../assets/images/pro.jpg');
                    background-size: cover;
                    background-position: center;
                }
                
                .content{
                    padding: 20px;
                    .title{
                        padding: 5px 0px;
                        font-weight: bold;
                        font-size: $h-news-title;
                    }
                    .lue{
                        overflow: hidden;
                        /* height: 49px; */
                        display: -webkit-box;
                        -webkit-line-clamp: 2;
                        -webkit-box-orient: vertical;
                        font-size: $h-font-16;
                        color: #000;
                        opacity: .7;
                    }
                    
                }
            }
        }
        .work-left{
            color: #FFF;
            z-index: 3;
            position: relative;
            @media only screen and (min-width: 992px){
                height: 525px;
            }
            display: flex;align-items: center;
            .content{
                position: relative;
                z-index: 3;
                width: 100%;
                font-size: $h-font-16;
                line-height: 28px;
                .detail{
                    @media only screen and (max-width: 900px){
                        padding: 50px 20px;
                    }
                    div:nth-child(1){
                        font-size: $h-shadow-sub;
                        padding: 20px 0;
                        font-weight: bold;
                    }
                }
            }
            &::after{
                content: '';
                width: 100%;
                height: 100%;
                position: absolute;
                top: 0;
                bottom: 0;
                right: 0;
                background-image: url('../assets/images/about/about-1.jpg');
                background-size: cover;
                background-position: center;
                z-index: 1
            }
            &::before{
                content: '';
                width: 100%;
                height: 100%;
                position: absolute;
                top: 0;
                bottom: 0;
                right: 0;
                background-color: rgba(186, 77, 72, .7);
                z-index:2
            }
        }
        .work-right{
            @media only screen and (max-width: 992px){
                margin-top: 20px;
            }
            @media only screen and (min-width: 992px){
                margin-left: 20px;
            }
            .flex{
                
            }
            .item{
                background-color: #FFFFFF;
                box-shadow: 2px 2px 5px #acacac;
                border-radius: 20px;
                overflow: hidden;
                transition: all 0.5s;
                &:hover{
                    box-shadow: 4px 4px 2px #e2e2e2;
                    cursor: pointer;
                    transform: scale(1.02) translateZ(0);
                    .thumb{
                        width: 300px;
                        max-width: 300px;;
                        .thumb-img{
                            width: 300px;
                            max-width: 300px;
                            transform: scale(1.1) translateZ(0);
                        }
                    }
                    
                }
                .thumb{
                    width: 300px;
                    min-width: 300px;
                    max-width: 300px;;
                    overflow: hidden;
                    .thumb-img{
                        background-position: center;
                        background-size: cover;
                        height:100%;min-width: 300px;
                        max-width: 300px;;
                        transition: all 0.5s;
                    }
                    
                }
                .content{
                    padding: 30px;
                    .title{
                        font-size: $h-news-title;
                        line-height: 28px;
                        overflow: hidden;
                        /* height: 49px; */
                        display: -webkit-box;
                        -webkit-line-clamp: 2;
                        -webkit-box-orient: vertical;
                    }
                    .lue{
                        margin-top: 10px;
                        opacity: .7;
                        font-size: $h-font-16;
                        overflow: hidden;
                        /* height: 49px; */
                        display: -webkit-box;
                        -webkit-line-clamp: 4;
                        -webkit-box-orient: vertical;
                    }
                }
                .flex{
                    height: 250px;
                    display: flex;
                    justify-content: space-between;
                }
                &+.item{
                    margin-top: 20px;
                }
            }
        }
        
    }
    
    .cpn-detail{
        @media only screen and (min-width:992px){
            height: 100vh;
        }
        
        .detail-main{
            padding: 5% 0px;
            height: calc(100vh - 5%);
            .detail-left{
                padding: 50px 0;
                .bg-item{
                    float: right;
                    div{
                        padding: 10px 15px 0;
                    }
                    p{
                        padding:0 15px 10px
                    }
                    
                }
                .hover-hand{
                    transition: all 0.8s ease-in-out;
                    &:hover{
                        color: #fff;
                        letter-spacing: 5px;
                        background-color: rgba(255, 255, 255, 0.1);
                    }
                }
                
                font-size: $h-font-25;
                p{
                    font-size: $h-font-15;
                }
                @media only screen and (min-width:992px){
                    height: 100%;
                    text-align: right;
                    
                }
                @media only screen and (max-width:900px){
                    text-align: center;
                    font-size: $h-font-16;
                }
                background-color: #BA4D48;
                color: #FFF;
                
                .active{
                    
                    font-weight: bold; 
                    background-color: #ffffff;
                    color: #BA4D48;
                }
            }
            .detail-right{
                @media only screen and (max-width:992px){
                    margin-top: 20px;
                    box-shadow: 0 0 2px 0 rgba(0, 0, 0, 0.1);
                    padding: 20px;
                }
                @media only screen and (min-width:992px){
                    height: 100%;
                }
                background-image: url('../assets/images/about/about-2.jpg');
                
                background-size: cover;
                background-position: right;
                display: flex;
                justify-content: center;
                padding-top: 5%;
                .detail-list{
                    font-size: $h-font-16;
                }
            }
        }
        
        
    }
    .about{
        .cpninfo{
            @media only screen and (min-width: 992px) {
                height: 100vh;
            }
            .cpn-left{
                @media only screen and (min-width: 992px) {
                    height: 100vh;
                }
                .content{
                    padding: 50px 0;
                }
                display: flex;
                align-items: center;
                justify-content: center;
                p{
                    font-size: $h-font-16;
                    text-indent: 30px;
                    line-height: 28px;
                }
            }
            .cpn-right{
                @media only screen and (min-width: 992px) {
                    height: 100vh;
                }
                background-image: url('../assets/images/about/about-1.jpg');
                background-size: cover;
                background-position: center;
                .content{
                    @media only screen and (min-width: 992px) {
                        height: 100vh;
                    }
                    display: flex;
                    align-items: center;
                    justify-content: center;
                    color: #FFF;
                    font-size:$h-tag-font ;
                    background-color: rgba(186, 77, 72, .7);
                    .msg{
                        padding: 25px;
                        position: relative;
                        font-weight: bold;
                        &::after{
                            position: relative;
                            content: attr(data-e);
                            font-size: $h-font-16;
                            margin-left: 4px;
                        }
                        &:before{
                            position: absolute;
                            content: attr(data-s);
                            font-size: $h-font-16;
                            top : 90px;
                        }
                    }
                }
            }
        }
    }
    .page-top{
        height: 100vh;
        width: 100vw;
        position: relative;
        background-image: url('https://scan-code.oss-cn-hangzhou.aliyuncs.com/menhu/pgtp/about.jpg');
        background-size: cover;
        background-position: center;
        align-items: center;
        .page-title{
            height: 100vh;
            align-items: center;
            display: flex;
            
        }
        h1{
            color: #fff;
            font-weight: bold;
        }
        h6{
            &+h6{
               border-top: 1px solid #acacac; 
               letter-spacing: 3px;
            }
            color: #fff;
            padding: 20px 0;
        }
    }
    .menu{
        letter-spacing: 3px;
        width: 100%;
        position: absolute;
        z-index: 99;
        bottom: 0;
        .item{
            transition: background .4s ease-in-out;
            padding: 15px 0;
            &+.item{
                border-left: 1px solid #acacac;
            }
        }
        .active{
            background-color: #BA4D48;
            color: #FFF;
        }
        .lose{
            background-color: #FFF;
            color: #000
        }
    }
    h4,h5{
        line-height: normal;
    }
    .select-swiper{
        display: flex;
        align-items: center;margin-top: 20px;
        .item-icon{
            background: var(--b);
            border-radius: 50%;
            width: 60px;
            height: 60px;
            text-align: center;
            align-items: center;
            line-height: 60px;
            display: flex;
            justify-content: center;
        }
        .item-title{
            background: var(--b);
            padding: 5px 20px;
            border-top-right-radius: 20px;
            border-bottom-right-radius: 20px;
            position: relative;
            left: -11px;
            z-index: -1;
        }
    }
    
</style>